import { post, fetch, patch, put, postJson, fetch_blob } from '../../http'
export default {
  //通知文件tab 查询部门列表
  getNoteDocTypeList(params) {
    return post('/ConfigureReports/notedoc/getNoteDocTypeList', params)
  },
}
